export const Constants = {
  versioApp: '0.0.1',
  ls: {
    user: 'ud',
    session: 'ss',
    cd: 'cd',
    at: 'at',
  },
  transactional: {
    created: 2,
    pending: 4,
    success: 5,
    denied: 6,
    error: 348,
    no_authorized: 446,
  },
  auth: {
    infodec: 'MTIzNDU2Nzg5MDowOTg3NjU0MzIx',
  },
  paths: {
    // Google Captchas
    captchasVerify: 'recaptcha/api/siteverify',

    // Ares Paths
    report_graphs: 'comercio-ventas/comercio-reportes',
    report_table: 'comercio-ventas/comercio-transacciones',
    period_tarification:
      'master-tarificacion-comercio/crud-master-periodo-tarificacion-comercio',
    auth_user: 'master-autenticacion-usuario-comercio/',

    // MGP Paths
    multitask: 'phrame.php',
    register: 'usuario/',
    login: 'auth/',
    checkMailVerification: 'auth_verificar/',
    loginAres: 'solicitud_token/',
    update_user: 'usuario_actualizar/',
    user_activation: 'solicitud_activacion/',
    contactar: 'contactar/',
    check_activation: 'activacion_consulta/',
    files: 'documentos_usuario/',
    check_files: 'verificar_documentos/',
    commerce: 'comercio/',
    agent: 'representante/',
    transactions: 'comercio-transaccion-comercio/',
    linkTransactions: 'comercio-transaccion-link-comercio',
    generateLink: 'paylink/',
    getTransactionData: 'transaccion/',
    getPayments: 'consulta_pagos/',
    commerceById: 'comercio_id/',
    emailVerification: 'verificacion_email/',
    transactionParams: 'consulta-parametros-comercio',
    linkUses: 'link_uso/',
    transactionResultAch: 'comercio-consulta-transaccion-link-comercio/',
    transactionResult: 'comercio-consulta-transaccion-comercio/',
    get_commerce: 'comercio_consulta/',
    get_commerce_accounts: 'cuentas_credibanco/',
    get_all_commerces: 'comercios/',
    get_contracts: 'contratos/',
    get_cities: 'ciudades/',
    get_activities: 'actividades_mcc/',
    get_bank_accounts: 'cuenta_bancaria_consulta/',
    plans: 'planes/',
    bank_accounts: 'cuenta_bancaria/',
  },
  servers: {
    ares: 'ARES',
    aresTransaccional: 'AREST',
    maxgp: 'maxGP',
    maxgpSystem: 'maxgpSystem',
    google: 'google',
  },
};
